import { format, parseISO } from 'date-fns';

export const CARD = 'bg-white rounded-xl border border-gray-200 shadow-sm';
export const INPUT =
  'rounded-md border border-gray-300 px-3 py-1.5 text-sm focus:border-claret-500 focus:outline-none focus:ring-1 focus:ring-claret-500';
export const PRIMARY =
  'rounded-md bg-claret-500 px-4 py-1.5 text-sm text-white hover:bg-claret-400 disabled:cursor-not-allowed disabled:opacity-50';
export const SECONDARY =
  'rounded-md border border-gray-300 bg-white px-4 py-1.5 text-sm text-gray-700 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50';

export const formatDateTime = (value) =>
  value ? format(parseISO(value), 'EEE d MMM, HH:mm') : '–';

// Totals across a preview's reminders.
export const previewTotals = (preview) => {
  const reminders = preview?.reminders ?? [];
  return reminders.reduce(
    (acc, r) => ({
      reminders: acc.reminders + 1,
      inApp: acc.inApp + (r.recipients?.in_app ?? 0),
      email: acc.email + (r.recipients?.email ?? 0),
      sms: acc.sms + (r.recipients?.sms ?? 0),
    }),
    { reminders: 0, inApp: 0, email: 0, sms: 0 }
  );
};

export const CHANNELS = [
  { key: 'in_app', label: 'In-app' },
  { key: 'email', label: 'Email' },
  { key: 'sms', label: 'SMS' },
];

export const STATUSES = [
  { key: 'queued', label: 'Queued' },
  { key: 'skipped', label: 'Skipped' },
  { key: 'failed', label: 'Failed' },
];
